import { render } from "./vipRight.vue?vue&type=template&id=1c071319&scoped=true&ts=true"
import script from "./vipRight.vue?vue&type=script&lang=ts"
export * from "./vipRight.vue?vue&type=script&lang=ts"

import "./vipRight.vue?vue&type=style&index=0&id=1c071319&lang=scss&scoped=true"

import exportComponent from "D:\\项目\\template\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c071319"]])

export default __exports__